import "@style/base.scss";
import "@style/iframe.scss";

import { initNoLazyLoad } from "@ui/lazy-load";
import { init, loadReactComponents } from "./common";
import { importComponent } from "./component";

init().then((components) => {
	initNoLazyLoad();

	loadReactComponents(components, importComponent);
});
